// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"input-check_checkbox__Vmetu","box":"input-check_box__LV_G0"};